import { Component, Input } from '@angular/core';
import { IUserIdentificationRequest } from '../../../../../classes/unlock-account-authentication';

@Component({
	selector: 'validate-auth-code',
	template: require('./validate-auth-code.component.html'),
})
export class ValidateAuthCodeComponent {
	@Input() identifyRequest: IUserIdentificationRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
	constructor() {}
}
